import { BillwerkChargeRecurringRequest } from 'src/app/model/interfaces/billwerk-charge-recurring';
import { ApiPostRequest } from '../api-post-request';

export class ChargeRecurringRequest extends ApiPostRequest
{
    public constructor(chargeRecurringRequest: BillwerkChargeRecurringRequest, webapiBasepath: string)
    {
        super('billwerk/chargerecurring',
        null,
        null,
        chargeRecurringRequest,
        webapiBasepath
    );
    }
}
